export const getAdAssetsStepViewStyles = () => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    gap: '32px',
  },
  'container-l': {
    width: 'calc(100% - 64px)',
  },
  formContainer: {
    width: '100%',
  },
  'formContainer-xxl': {
    width: '530px',
  },
  'formContainer-xl': {
    width: '430px',
  },
  title: {
    marginTop: '0',
    marginBottom: '16px',
  },
  description: {
    marginBottom: '32px',
  },
  previewerContainer: {
    flexGrow: '1',
  },
  'previewerContainer-l': {
    width: 'calc(100% - 64px)',
  },
  'previewerContainer-m': {
    width: 'calc(100% - 64px)',
  },
  'previewerContainer-s': {
    width: 'calc(100% - 64px)',
  },
});
